<template>
	<div>
		<div class="list padding-tb-sm margin-top-sm bg-white" @click="godetail(1)">
			<div class="fu-fs34 padding-lr-sm padding-bottom-xs text-left margin-bottom-sm titl">{{data.invoice_head.invoice_type | fityinvoice}}</div>
			<div class="padding-lr-sm">
				<div class="flex align-center room">
					<div class="fu-fs26 text-ccc rom-title">抬头类型</div>
					<div class="fu-fs26 text-666">{{data.type | fitytype}}</div>
				</div>
				<div class="flex align-center room">
					<div class="fu-fs26 text-ccc rom-title">开票金额</div>
					<div class="text-theme fu-fs26">{{data.price}}元</div>
				</div>
				<div class="flex align-center room">
					<div class="fu-fs26 text-ccc rom-title">开票内容</div>
					<div class="fu-fs26 text-666">{{data.content}}</div>
				</div>
				<div class="text-right fu-fs26 text-ccc">{{data.create_time}}</div>
			</div>
			<div v-if="data.status == 2" class="status text-center text-theme fu-fs26 unpay">已开票</div>
			<div v-if="data.status == 3" class="status text-center text-theme fu-fs26 paied">已驳回</div>
			<div v-if="data.status == 1" class="status text-center text-theme fu-fs26 redived">待审核</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {

			}
		},
		methods: {
			godetail(item) {
				console.log(item);
				this.$emit('godetail', item)
			}
		},
		filters:{
			fityinvoice(val){
				switch (val) {
					case 1:
						return '增值税普通发票'
						break;
					case 2:
						return '增值税专用发票'
						break;
					default:
						break;
				}
			},
			fitytype(val){
				switch (val) {
					case 2:
						return '企业'
						break;
					case 1:
						return '个人'
						break;
					default:
						break;
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.list {
		position: relative;
		border-radius: 20px;

		.titl {
			font-size: 24px;
			border-bottom: 1px solid #E6E6E8;
		}

		.status {
			position: absolute;
			top: 0;
			right: 0;
			width: 64px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}

		.unpay {
			background: rgba(11, 131, 124, 0.1000);
			color: #0B837C;
		}

		.paied {
			color: #DF1510;
			background: rgba(223, 21, 16, 0.1);
		}

		.reviewed {
			color: #568EEB;
			background: rgba(120, 147, 255, 0.1);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/list/invoice-list.vue